module.exports = [
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/bmp',
  'image/tiff',
  'video/mp4',
  'video/m4p',
  'video/m4v',
  'video/3gp',
  'video/mov',
  'video/avi'
];
